import { useNavigate } from "react-router-dom"

const Unauthorized = () => {
    const navigate = useNavigate();
const test= localStorage.getItem('rUser')
    const tt11 = localStorage.getItem('xsrfToken')
    const goBack = () => navigate(-1);

    return (
        <section>
            <h1>Unauthorized</h1>
            <br />
            <p>You do not have access to the requested page  TW.</p>
            <div className="flexGrow">
                <button onClick={goBack}>Go Back</button>
            </div>
        </section>
    )
}

export default Unauthorized